export default [
  {
    path: '/account/settings/basic',
    name: 'AccountBasic',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Basic.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      showDetails: true,
      title: 'Configuración de la organización'
    }
  },
  {
    path: '/account/settings/email',
    name: 'AccountSettingsEmail',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Email.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Email'
    }
  },
  {
    path: '/account/settings/branding',
    name: 'AccountSettingsBranding',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Branding.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Branding'
    }
  },
  {
    path: '/account/settings/invoicing',
    name: 'AccountSettingsInvoicing',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Invoicing.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturación'
    }
  },
  {
    path: '/account/settings/bank',
    name: 'AccountSettingsBank',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Bank.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Banco'
    }
  },
  {
    path: '/account/settings/bank/success',
    name: 'AccountSuccessBank',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/BankSuccess.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Banco success'
    }
  },
  {
    path: '/account/settings/payments',
    name: 'AccountSettingsPayments',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Payments.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Pagos'
    }
  },
  {
    path: '/account/settings/webhooks',
    name: 'AccountSettingsWebhooksListCreate',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/WebhooksListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Webhooks'
    }
  },
  {
    path: '/account/settings/webhooks/:id',
    name: 'AccountSettingsWebhooksRetrieveUpdate',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/WebhooksRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Webhooks'
    }
  },
  {
    path: '/account/settings/billing',
    name: 'AccountBilling',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Billing.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Facturación de Piriod'
    }
  },
  {
    path: '/account/settings/members',
    name: 'AccountMembers',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Members.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Equipo'
    }
  },
  {
    path: '/account/choose',
    name: 'AccountChoose',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Choose.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      requireAuth: true,
      requireAccount: false,
      title: 'Cambio de cuenta'
    }
  },
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Choose.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      requireAuth: true,
      requireAccount: true,
      title: 'Cambio de cuenta'
    }
  },
  {
    path: '/account/dashboard',
    name: 'AccountDashboard',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Dashboard.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountDashboard',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/account/setup',
    name: 'AccountSetup',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Setup.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Setup'
    }
  },
  {
    path: '/account/import/invoices',
    name: 'AccountImportInvoices',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/ImportInvoices.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Importación de facturas'
    }
  },
  {
    path: '/account/import/credit-notes',
    name: 'AccountImportCreditNotes',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/ImportCreditNotes.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Importación de facturas'
    }
  },
  {
    path: '/account/exports',
    name: 'AccountExports',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Exports.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/customers',
    name: 'AccountCustomerExport',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/exports/CustomerExport.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/subscriptions',
    name: 'AccountExportSubscription',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/exports/ExportSubscription.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/invoices',
    name: 'AccountExportInvoices',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/exports/ExportInvoices.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/credit_notes',
    name: 'AccountExportCreditNote',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/exports/ExportCreditNote.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/payments',
    name: 'AccountExportPayment',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/exports/ExportPayment.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/ach_transfers',
    name: 'TransactionExport',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/exports/TransactionExport.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/imports',
    name: 'AccountImports',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/Imports.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/imports/customers',
    name: 'AccountImportCustomers',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/imports/ImportCustomers.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/imports/usages',
    name: 'ImportUsages',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/imports/ImportUsages.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/user/onboarding',
    name: 'UserOnboarding',
    component: () => import(/* webpackChunkName: "onboarding" */ '@/views/account/UserOnboarding.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      requireAuth: true,
      title: 'Sobre ti',
      whiteBackground: true
    }
  },
  {
    path: '/organizations/create',
    name: 'OrganizationCreate',
    component: () => import(/* webpackChunkName: "onboarding" */ '@/views/account/OrganizationCreate.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      requireAuth: true,
      requireAccount: false,
      title: 'Crea tu organización',
      whiteBackground: true
    }
  },
  {
    path: '/organizations/onboarding',
    name: 'OrganizationOnboarding',
    component: () => import(/* webpackChunkName: "onboarding" */ '@/views/account/OrganizationOnboarding.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      requireAuth: true,
      title: 'Configura tu organización',
      whiteBackground: true
    }
  },
  {
    path: '/organizations/with-piriod',
    name: 'OrganizationWithPiriod',
    component: () => import(/* webpackChunkName: "accounts" */ '@/views/account/OrganizationWithPiriod.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: false,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Tu flujo personalizado',
      whiteBackground: true
    }
  }
]